import { CustomEventWithDetail } from 'rune-ts';

export class BecomeFanButtonEvent extends CustomEventWithDetail<{
  is_liked: boolean;
  store_id: number;
}> {}
